import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import jwtEncode from 'jwt-encode';
import axios from "axios";
import Header from "./components/layouts/header";
import Sidebar from "./components/layouts/sidebar";
import AppRouter from "./components/appRouter";
import { saveConfig , saveLandingConfig} from "./store/slice/configSlice";
import { saveUserData, saveCertificate, saveUserPlan } from "./store/slice/userSlice";
import { UNO_URL, applicationId } from "./env";
import FullScreenLoader from "./components/FullScreenLoader/fullScreenLoader";
import { myApplicationList, addTagCategories, addCategories } from "./store/slice/applicationSlice";
import useWindowDimensions, { getUserCertificate } from './utils/useWindowDimensions';


const App = () => {
  let {width , height} = useWindowDimensions()
  const dispatch = useDispatch();
  const [sideBar, setSideBar] = useState(width > 800 ? (false) : (true));
  const [loading, setLoading] = useState(true);
  const [redirectUri, setRedirectUri] = useState(null);
  const [userPlan, setUserPlan] =  useState("pro")


  const getXrLandingDetails = async() =>{
    setLoading(true);
    let {data} = await axios.get(`${UNO_URL}/api/application/landing/configuration/${applicationId}`, {
      headers: {
        Authorization: `Bearer `,
      }});

      let visibleSections = data?.data?.visibleSections || [];
      let appId = data.data.applicationId;

      dispatch(saveLandingConfig({
        visibleSections : visibleSections,
        home : data?.data?.home || null,
        about : data?.data?.about || null,
        contact : data?.data?.contact || null
      }));

      getConfiguration(visibleSections, appId);
    }

  const getConfiguration = async (visibleSections, appId) => {
  
    await axios.get(`${UNO_URL}/api/application/configuration/${appId}`)
      .then((response) => {
        let data = response.data.data.data;
        // data.API_URL = "http://localhost:3033";
        // data.UNO_URL = "http://localhost:3003";
        dispatch(saveConfig({ data }));
        getUserDetail(data, visibleSections, appId);
        getAllModuleFilterCategories(data);
        getAllTagCategories(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getXrLandingDetails();
  }, []);

  const fetchApplication = async (token, config) => {
    try {
      var { data } = await axios.get(`${config.UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(myApplicationList(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  const getAllModuleFilterCategories = async (config) => {
    try {
      
      let tagCategoryId = config.MODE === "XR" ? config.moduleFilterId : config.skillStream2DFilterId;

      const moduleTags = await axios.get(`${config.UNO_URL}/api/tag/list/${tagCategoryId}`, {
        headers: { Authorization: `Bearer ` },
      });

      const moduleFilterList = moduleTags.data || [];
      dispatch(addTagCategories(moduleFilterList));

    } catch (error) {
      console.error(error);
    }
  };

  const getAllTagCategories = async (config) => {
    try {
      
      const moduleTags = await axios.get(`${config.UNO_URL}/api/tag/list/${config.categoryFilterId}`, {
        headers: { Authorization: `Bearer ` },
      });

      const categoryFilterList = moduleTags.data || [];
      let itiFilterList = categoryFilterList?.data?.children?.find(e => e.id === 229) || [];
      dispatch(addCategories({
        data: {
          ...itiFilterList,
          parent: null,
          parentId: null
        },
        status: true
      }));

    } catch (error) {
      console.error(error);
    }
  };

  const checkLoggedStatus = (config, token, visibleSections) => {

    if(!token && !visibleSections.includes('explore') ) {
          localStorage.clear();
          sessionStorage.clear();
          const payload = {
            origin: window.location.origin,
            redirectUri: window.location.pathname
          };
          const token = jwtEncode(payload, "");
          return (window.location.href = `${config.redirectUri}?referrer=${token}`);
    }
        
    if(token && !visibleSections.includes('explore') ) {
          setLoading(false);
          return
        }

    if (token || visibleSections.includes('home') || visibleSections.includes('explore') || visibleSections.includes('aboutUs') || visibleSections.includes('contactUs') ) {
      setLoading(false);
    } else {
      localStorage.clear();
      sessionStorage.clear();
      const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname
      };
      const token = jwtEncode(payload, "");
      return (window.location.href = `${config.redirectUri}?referrer=${token}`);
    }

  }

  const getUserDetail = async (config, visibleSections, appId) => {
    try {
      
          const urlParams = new URLSearchParams(window.location.search);
          const _tokenParam = urlParams.get("referrer");
          let token = "";

          if (_tokenParam) {
            const decoded = jwtDecode(_tokenParam);
            localStorage.setItem("token", decoded.token);
            token = decoded.token;
            if (decoded.redirectUri) setRedirectUri(decoded.redirectUri);
          } else if (localStorage.getItem("token")) {
            token = localStorage.getItem("token");
          }

          let {data} = await axios.get(`${config.UNO_URL}/api/user/me`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                } });

          let plansFind = await axios.get(`${config.UNO_URL}/api/user/plan/subscription/${appId}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            } });
          
          let plan={...plansFind.data.data};

          localStorage.setItem("token", data.data.token);
          const _data = {
                token: data.data.token,
                user: data.data.user,
              };
          
            dispatch(saveUserData(_data));
            dispatch(saveUserPlan(plan));
            fetchApplication(_data.token, config);
            checkLoggedStatus(config, _data.token, visibleSections);
            let _certificate= await getUserCertificate(config.UNO_URL, _data.token, config.MODE)
            dispatch(saveCertificate(_certificate));
      
    } catch (error) {
      checkLoggedStatus(config, null, visibleSections);
      console.log(error);
    }
     };

  return (
    <>
      {loading ? (
        <FullScreenLoader loading={loading} />
      ) : (
        <>
          <Router>
            <Header sideBar={sideBar} setSideBar={setSideBar} />
            <Sidebar sideBar={sideBar} _userPlan={userPlan}  />
            <div className={sideBar ? "main-content sideactive" : "main-content"} >
              <AppRouter redirectUri={redirectUri} userPlan={userPlan} />
            </div>
          </Router>
        </>
      )}
    </>
  );
};

export default App;